import '../plugins/CustomFormsPlugin.js';
import SimpleBar from 'simplebar';


// initialize custom form elements
export default function initCustomForms() {
	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
		maxVisibleItems: 9,
		fakeDropInBody: false,
		useCustomScroll: function(self) {
			const simpleBar = new SimpleBar(self.listHolder[0], {
				autoHide: false,
				clickOnTrack: true
			});
		}
	});
	jcf.replaceAll();
}